import React, { Component } from 'react';

import { StyledLegend } from './styles/StyledLegend';


class Legend extends Component {
  render() {
  
    return (
      <StyledLegend>
        <ul className="list-inline">
          <li>

            <i className="fa fa-stop calendar-legend-occupied" aria-hidden="true"></i>
            <span> - obsazený termín </span>

          </li>
          <li>

            <i className="fa fa-stop calendar-legend-holiday" aria-hidden="true"></i>
            <span> - svátek </span>

          </li>
          <li>

            <i className="fa fa-stop calendar-legend-blocked" aria-hidden="true"></i>
            <span> - nepřístupný termín </span>

          </li>
          <li>

            <i className="fa fa-stop alendar-legend-free" aria-hidden="true"></i>
            <span> - volný termín </span>

          </li>
        </ul>
      </StyledLegend>
    );
  }
}

export default Legend;



// WEBPACK FOOTER //
// ./src/components/IntervalsContent/Legend.js